module.exports = __webpack_public_path__ + "img/exam_jan_2025_mr4o2752.5bc9da2a.jpg";